import { render, staticRenderFns } from "./healthDetail.vue?vue&type=template&id=840d240e&scoped=true&"
import script from "./healthDetail.vue?vue&type=script&lang=js&"
export * from "./healthDetail.vue?vue&type=script&lang=js&"
import style0 from "./healthDetail.vue?vue&type=style&index=0&id=840d240e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840d240e",
  null
  
)

export default component.exports